import Action from './Action';
import * as ActionMethods from './ActionMethods';

import AuthorizationService from '../services/AuthorizationService';
import CommonService from '../services/CommonService';
import CutomerService from '../services/CustomerService'
import PaymentService from '../services/PaymentService';
import ClientService from '../services/ClientService';
import LocalStorageService from '../services/LocalStorageService';
import EventDispatcher from "../framework/EventDispatcher";
import ApplicationStore from '../framework/ApplicationStore';
import Customer from '../model/account/Customer';
import CustomerDto from '../model/account/CustomerDto';
import PaymentMethodDto from '../model/payment/PaymentMethodDto';
import Error from '../model/Error';
import ContractDetails from "../model/ContractDetails";
import ServiceDocument from "../services/ServiceDocument";
import ServiceSeller from "../services/ServiceSeller";
import ProcedureDetails from "../model/ProcedureDetails";

export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_HIERARCHY = "UPDATE_HIERARCHY";
export const FIND_CUSTOMER = "FIND_CUSTOMER";
export const UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD";
export const DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD";
export const CLEAR = "CLEAR";
export const RESET_MODALS = "RESET_MODALS";
export const CREATE_CONTRACT = "CREATE_CONTRACT";
export const CREATE_PROCEDURE = "CREATE_PROCEDURE";
export const CLOSE_DOCUMENT_SIGN_MODAL = "CLOSE_DOCUMENT_SIGN_MODAL";
export const OPEN_MODAL = "OPEN_MODAL";
export const OPEN_MODAL_CB = "OPEN_MODAL_CB";
export const CLOSE_MODAL_CB = "CLOSE_MODAL_CB";
export const REFRESH = "REFRESH";
export const CLOSE_MODAL ="CLOSE_MODAL";
export const OPEN_MODAL_CB_2 = "OPEN_MODAL_CB_2";
export const OPEN_MODAL_CB_3 = "OPEN_MODAL_CB_3";
export const CLOSE_MODAL_CB_2 = "CLOSE_MODAL_CB_2";
export const CLOSE_MODAL_CB_3 = "CLOSE_MODAL_CB_3";
export const OPEN_MODAL_2 = "OPEN_MODAL_2";
export const CLOSE_MODAL_2 ="CLOSE_MODAL_2";
export const CLOSEREFRESH ="CLOSEREFRESH";
export const OPEN_REDIRECT_MODAL = "OPEN_REDIRECT_MODAL";
export const CLOSE_REDIRECT_MODAL = "CLOSE_REDIRECT_MODAL";
export const GET_PROCEDURE_STATUS = "GET_PROCEDURE_STATUS";
export const GET_ACCOUNT = "GET_ACCOUNT";
export const GET_CONTACT = "GET_CONTACT";
export const NEW_PAYMENT_METHOD = "NEW_PAYMENT_METHOD";

export default function reducer (state ={}, action={}){
	switch (action.type) {
		case EventDispatcher.successAction(CLEAR):
			return {
				...state,
				status:"",
				message:""
			};
			break;
		case EventDispatcher.successAction(RESET_MODALS):
			return {
				...state,
				...state,
				showModalCB_2: false,
				showModal_2: false
			};
			break;
		case EventDispatcher.successAction(FIND_CUSTOMER):
		case EventDispatcher.successAction(UPDATE_HIERARCHY):
		const {customer} = action.data;
		return {
			...state,
			customer
		};
		break;
		case EventDispatcher.successAction(UPDATE_CUSTOMER):
		const {message} = action.data;
		return {
			...state,
			message
		};
		case EventDispatcher.errorAction(UPDATE_PAYMENT_METHOD):
		const {error, status} = action.data;
		return {
			...state,
			status,
			message: error.message
		};
		case EventDispatcher.successAction(GET_PROCEDURE_STATUS): {
			const {status} = action.data;
			return {
				...state,
				procedure: {
					...state.procedure,
					status: {
						...state.status,
						...status
					}
				}
			};
		}
		case EventDispatcher.errorAction(CREATE_CONTRACT):
		
			return {
				...state,
				message: action.data.error.message
			};
		case EventDispatcher.successAction(CREATE_CONTRACT): {
			const {pdfFilePath, contract, status} = action.data;
			return {
				...state,
				pdfFilePath,
				contract,
				status: {
					...state.status,
					...status
				}
			};
		}
		case EventDispatcher.successAction(CREATE_PROCEDURE): {
			const {procedure, status} = action.data;
			return {
				...state,
				procedure,
				showDocumentSignModal: true,
				status: {
					...state.status,
					...status
				}
			};
		}
		case EventDispatcher.successAction(GET_CONTACT): {
			const {contact} = action.data;
			return {
				...state,
				contact
			};
		}
		case EventDispatcher.successAction(GET_ACCOUNT): {
			const {customer, contact} = action.data;
			return {
				...state,
				customer,
				contact
			};
		}
		case EventDispatcher.errorAction(GET_CONTACT): {
			const {contact, error} = action.data;
			return {
				...state,
				message: action.data.error.message,
				error
			};
		}
		case EventDispatcher.errorAction(CREATE_PROCEDURE):
			return {
				...state,
				message: action.data.error.message
			};
			break;
		case EventDispatcher.successAction(CLOSE_DOCUMENT_SIGN_MODAL): {
			return {
				...state,
				showDocumentSignModal: false
			};
		}
		case EventDispatcher.successAction(OPEN_REDIRECT_MODAL): {
			return {
				...state,
				openRedirect: true
			};
		}
		case EventDispatcher.successAction(CLOSE_REDIRECT_MODAL): {
			return {
				...state,
				openRedirect: false
			};
		}
			break;
		case EventDispatcher.successAction(OPEN_MODAL): {
			return {
				...state,
				showModal: true
			};
		}
			break;
		case EventDispatcher.successAction(OPEN_MODAL_2): {
			return {
				...state,
				showModal_2: true
			};
		}
			break;
		case EventDispatcher.successAction(OPEN_MODAL_CB): {
			return {
				...state,
				showModalCB: true
			};
		}
			break;
		case EventDispatcher.successAction(REFRESH): {
			return {
				...state,
				refresh: true
			};
		}
			break;
		case EventDispatcher.successAction(CLOSEREFRESH): {
			return {
				...state,
				refresh: false
			};
		}
			break;
		case EventDispatcher.successAction(OPEN_MODAL_CB_2): {
			return {
				...state,
				showModalCB_2: true
			};
		}
			break;
		case EventDispatcher.successAction(OPEN_MODAL_CB_3): {
			return {
				...state,
				showModalCB_3: true
			};
		}
			break;
		case EventDispatcher.successAction(CLOSE_MODAL_CB): {
			return {
				...state,
				showModalCB: false
			};
		}
			break;
		case EventDispatcher.successAction(CLOSE_MODAL_CB_2): {
			return {
				...state,
				showModalCB_2: false
			};
		}
			break;
		case EventDispatcher.successAction(CLOSE_MODAL_CB_3): {
			return {
				...state,
				showModalCB_3: false
			};
		}
			break;
		case EventDispatcher.successAction(CLOSE_MODAL): {
			return {
				...state,
				showModal: false
			};
		}
			break;
		case EventDispatcher.successAction(CLOSE_MODAL_2): {
			return {
				...state,
				showModal_2: false
			};
		}
			break;
		case EventDispatcher.successAction(UPDATE_PAYMENT_METHOD): {
			return {
				...state,
				//showModal: false,
				status: action.data.status
			};
		}
		 	break;
		case EventDispatcher.successAction(DELETE_PAYMENT_METHOD): {
			return {
				...state,
				message: action.data.message
			};
		}
			break;
		default:
		return state;
	}
}
export function signupCustomer(data) {
	const action = new Action(ActionMethods.SIGNUP_CUSTOMER, function (data) {
		ClientService.Create(data)
			.then(() => {
				this.success();
			}).catch(() => {
			this.fail({
				errorCode: "FAIL",
				message: "Registration failed"
			});
		});
	});

	action.execute(data);

}

export function updateHierarchy(data) {
	return dispatch => {
		ClientService.UpdateClient(data)
		.then((response) => {
				if (response.status === "FAIL") {
					this.fail(response);
				} else {
					CommonService.findUser(data.userName)
						.then(oResponse => {
							const {actionStatus, customers} = oResponse;
							const {customer} = customers || {};
							const [firstCustomer] = customer || [];
							if (actionStatus === null || actionStatus.status === "FAIL") {
								this.fail(actionStatus);
							} else if (firstCustomer === null) {
								this.fail({
									message: "No customer found."
								});
							} else {
								const customer = new Customer(firstCustomer);
								LocalStorageService.setCurrentCustomer(customer);
								customer.success = "success";
								EventDispatcher.success(dispatch, UPDATE_HIERARCHY, {customer});
							}
						})
						.catch(error => {
							EventDispatcher.error(dispatch, UPDATE_HIERARCHY, error);
						});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, UPDATE_HIERARCHY, error);
			});
		};
	}

	export function updateCustomer(data) {
		return (dispatch, getState) => {
			EventDispatcher.loading(dispatch, UPDATE_CUSTOMER);
			const {messages: mainMessages={}} = getState();
			const {messages = {}} = mainMessages || {};
			const customer = new CustomerDto(data);
			CutomerService.updateCustomer(customer)
				.then(response => {
					if (response === null || response.status === "FAIL") {
						throw response;
					} else {
						const currentCustomer = LocalStorageService.getCurrentCustomer();
						if (currentCustomer === null) {
							this.fail(new Error({message: messages["common.error.no.customer.found"]}));
						} else {
							CommonService.findCustomer(currentCustomer.code)
								.then(response => {
										const {actionStatus, customers} = response;
										const {customer} = customers || {};
										const [firstCustomer] = customer || [];
										if (actionStatus === null || actionStatus.status === "FAIL") {
											this.fail(actionStatus);
										} else if (firstCustomer === null) {
											this.fail({
												message: "No customer found."
											});
										} else {
											const customer = new Customer(firstCustomer);
											LocalStorageService.setCurrentCustomer(customer);
											EventDispatcher.success(dispatch, FIND_CUSTOMER, {customer});
										}
									})
								.catch(error => {
									EventDispatcher.error(dispatch, FIND_CUSTOMER, error);

								});

						EventDispatcher.success(dispatch, UPDATE_CUSTOMER, {
							message:"Client mis à jour avec succès.",
						});
					}

				}})
				.catch(error => {
					EventDispatcher.error(dispatch, UPDATE_CUSTOMER, error);
				});
		};
	}

export function updateUser(data) {
	const action = new Action(ActionMethods.UPDATE_USER, function (data) {
		ClientService.UpdateUser(data).then(
			(response) => {
				if (response === null || response.status === "FAIL") {
					this.fail(response);
				} else {
					const currentCustomer = LocalStorageService.getCurrentCustomer();
					const customer = {...currentCustomer};
					customer.success = "success";
					this.success(customer);

				}
			},
			(err) => {
				this.fail(err);
			}
		);
	});
	action.execute(data);
}

export function loadContactDetails(pmCode, resume) {
	return (dispatch, getState)=> {
		EventDispatcher.loading(dispatch, GET_ACCOUNT);
		const {messages: mainMessages={}} = getState();
		const {messages = {}} = mainMessages || {};
		const {email: contactEmail} = AuthorizationService.auth.tokenParsed || {};
		if (!contactEmail) {
			resume(null, new Error({message: messages["common.error.connected.user.has.no.email"]}));
			return;
		}
		const params = {
			filters: {
				contactInformation : {
					'email': contactEmail
				}
			}
		};
		CutomerService.findContactInfo(params)
			.then(response => {
				const {status} = response;
				if (status === null || status === "FAIL") {
					throw status;
				} else {
					const contactInfo = response.data || [];
					if (contactInfo.length == 0) {
						resume(null, new Error({message: messages["common.error.contact.not.found"]}));
						return;
					} else {
						const contact = contactInfo[0] || {};
						resume(contact, null);
					}
				}
			}).catch(error => {
			resume(null, error);
		})
	}
}

export function forgotPassword(email) {
	const action = new Action(ActionMethods.FORGOT_PASSWORD, function (email) {
		CommonService.forgotPassword(email);
		this.success();
	});

	action.execute(email);

}

export function getCurrentCustomer() {
	const action = new Action(ActionMethods.GET_CURRENT_CUSTOMER, function () {
		const currentCustomer = LocalStorageService.getCurrentCustomer();
		if (currentCustomer === null) {
			return this.success(null);
		}
		return this.success(currentCustomer);
	});

	action.execute();
}

export function logoutCurrentCustomer() {
	const action = new Action(ActionMethods.LOGOUT_CURRENT_CUSTOMER, function () {
		const currentCustomer = LocalStorageService.getCurrentCustomer();
		if (currentCustomer === null) {
			const {messages: mainMessages={}} = ApplicationStore.getState();
			const {messages = {}} = mainMessages || {};
			this.fail(new Error({message: messages["common.error.no.customer.found"]}));
		}
		LocalStorageService.removeCurrentCustomer();
		AuthorizationService.auth.logout({redirectUri: REDIRECT_URL});
		return this.success();
	});

	action.execute();

}

export function clear() {
	return dispatch => {
		EventDispatcher.success(dispatch, CLEAR);
	};
}
export function resetModals() {
	return dispatch => {
		EventDispatcher.success(dispatch, RESET_MODALS);
	};
}

export function getProcedureStatus(procedureId, customerAccount, newPaymentMethod, oldPaymentMethodId) {
	return (dispatch, getState) => {
		EventDispatcher.loading(dispatch, UPDATE_PAYMENT_METHOD);
		ServiceDocument.getProcedureStatusById(procedureId)
			.then(response => {
				const {messages: mainMessages={}} = getState();
				const {messages = {}} = mainMessages || {};
				const {actionStatus} = response;
				if (actionStatus === null || actionStatus.status === "FAIL") {
					throw status;
				} else {
					const status= response.response || {};
					if( status=== "finished"){
						PaymentService.createPaymentMethod(newPaymentMethod)
							.then(response => {
								if (response === null || response.status === "FAIL") {
									throw response;
								} else{
									const {paymentMethod} = response;
									LocalStorageService.remove('NEW_PAYMENT_METHOD');
									PaymentService.approveSepaDDMandate(customerAccount)
										.then(response => {
											const {status} = response;
											if (status=== null || status === "FAIL") {
												throw status;
											} else {
												const {mandateIdentification} = newPaymentMethod || ""
												PaymentService.checkMandate(mandateIdentification,customerAccount)
													.then(response => {
														const {status} = response;
														if (status === null || status === "FAIL") {
															throw status;
														} else {
															const {state:documentSigned} = response
															if(documentSigned ==="active"){
																dispatch(deletePaymentMethod(oldPaymentMethodId));
																dispatch(findCustomer());
																EventDispatcher.success(dispatch, GET_PROCEDURE_STATUS, {status: {documentSigned}});
															} else {
																EventDispatcher.error(dispatch, GET_PROCEDURE_STATUS,  {message: messages["common.error.mandate.reference"], status:"FAIL"});
															}
														}
													})
													.catch(error => {
														EventDispatcher.error(dispatch, GET_PROCEDURE_STATUS,  {message:error.message, status:"FAIL"});
													});
											}
										})
										.catch(error => {
											EventDispatcher.error(dispatch, GET_PROCEDURE_STATUS,  {message:error.message, status:"FAIL"});
										});

								}
							})
							.catch(error => {
								EventDispatcher.error(dispatch, UPDATE_PAYMENT_METHOD,  {message:error.message, status:"FAIL"});
							});
					} else	{		
						EventDispatcher.error(dispatch, GET_PROCEDURE_STATUS,{ message: messages["common.error.mandate.reference"]});
					}
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, GET_PROCEDURE_STATUS,  {message:error.message, status:"FAIL"});
			});
	};
}

export function createProcedure(paymentMethod, listPdfFilePaths, offer, code, userAccount) {
	return dispatch => {
		EventDispatcher.loading(dispatch, CREATE_PROCEDURE);
		
		const procedure = new ProcedureDetails(paymentMethod, listPdfFilePaths, offer, code, userAccount);
		ServiceDocument.createProcedure(procedure)
			.then(response => {
				const {actionStatus, ...details} = response;
				if (actionStatus === null || actionStatus.status === "FAIL") {
					throw status;
				} else {
					EventDispatcher.success(dispatch, CREATE_PROCEDURE, { procedure: details, status: { procedureCreated: actionStatus.status } });
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, CREATE_PROCEDURE,  {message:"Yousign error", status:"FAIL"});
			});
	};
}

export function updatePaymentMethod(paymentMethod, offer, subscription, userAccount) {
	return (dispatch, getState) => {
		EventDispatcher.loading(dispatch, UPDATE_PAYMENT_METHOD);
		const {messages: mainMessages={}} = getState();
		const {messages = {}} = mainMessages || {};
		const {seller, code } = subscription || "";
		if (!paymentMethod) {
			EventDispatcher.error(dispatch, UPDATE_PAYMENT_METHOD, {message: messages["common.error.no.payment.method.to.update"]});
		} else {
			// const {iban, bic} = paymentMethod.bankCoordinates || "";
			const {iban} = paymentMethod.bankCoordinates || "";
			// if (!iban.startsWith("FR")) {
			// 	EventDispatcher.error(dispatch, VALIDATE_PAYMENT, {message: messages["common.error.invalid.iban"], status:"FAIL"});
			// } else {
				// PaymentService.validate(iban, bic)
				PaymentService.validate(iban)
					.then(response => {
						if (response === null || response.status === "FAIL") {
							throw response;
						} else {
							PaymentService.rumSequences()
								.then(response => {
									const {actionStatus, value} = response;
									if (response === null || actionStatus.status === "FAIL") {
										throw response;
									} else {
										paymentMethod.mandateIdentification = value;
										dispatch(createContract(paymentMethod, offer, subscription, userAccount, value));
										LocalStorageService.set(NEW_PAYMENT_METHOD, new PaymentMethodDto(paymentMethod, value));
										EventDispatcher.successAction(dispatch, UPDATE_PAYMENT_METHOD, {
											paymentMethod,
											status: "SUCCESS"
										});
									}
								})
								.catch(error => {
									EventDispatcher.error(dispatch, UPDATE_PAYMENT_METHOD, {
										message: "RUM non généré",
										status: "FAIL"
									});
								});
						}
					})
					.catch(error => {
						EventDispatcher.error(dispatch, UPDATE_PAYMENT_METHOD, {
							message: "IBAN incorrecte",
							status: "FAIL"
						});
					});

				// }
			}
		}
	}


export function createContract(paymentMethod, offer, subscription, userAccount, value) {
	
	return (dispatch, getState) => {
		EventDispatcher.loading(dispatch, CREATE_CONTRACT);
			const {seller, code } = subscription || "";
			ServiceSeller.getSeller(seller.code)
				.then(response => {
					const { actionStatus } = response;
					if (actionStatus === null || actionStatus.status === "FAIL") {
						throw status;
					} else {
						const juridique = response || {};
						const contract = new ContractDetails(paymentMethod, subscription, value, juridique,userAccount);
						ServiceDocument.createContract(contract)
						    .then(response => {
								const { actionStatus } = response;
								if (actionStatus === null || actionStatus.status === "FAIL") {
									throw status;
								} else {
									const { pdfFilePath, listPdfFilePaths } = response;
									dispatch(createProcedure(paymentMethod, listPdfFilePaths, offer, code, userAccount))
									EventDispatcher.success(dispatch, CREATE_CONTRACT, { pdfFilePath, contract, status: { contractCreated: actionStatus.status } });
									}
								})
															
								.catch(error => {
									EventDispatcher.error(dispatch, CREATE_CONTRACT, error);
								});							
		
					}})
					.catch(error => {
						EventDispatcher.error(dispatch, CREATE_CONTRACT, error);
					});
	
			}
		}
		
 export function deletePaymentMethod(id) {
		return (dispatch, getState) => {
			EventDispatcher.loading(dispatch, DELETE_PAYMENT_METHOD);
			PaymentService.deletePaymentMethod(id)
				.then(response => {
					if (response === null || response.status === "FAIL") throw response;
				})
				.then(() => {
					EventDispatcher.success(dispatch, DELETE_PAYMENT_METHOD, {message: "payment.method.delete.success"});
				})
				.catch(error => {
					EventDispatcher.error(dispatch, DELETE_PAYMENT_METHOD, error);
				});
		};
	}

	export function closeDocumentSignModal() {
		return dispatch => {
			EventDispatcher.success(dispatch, CLOSE_DOCUMENT_SIGN_MODAL);
		};
	}

	export function openRedirectModal() {
		return dispatch => {
			EventDispatcher.success(dispatch, OPEN_REDIRECT_MODAL);
		};
	}

	export function closeRedirectModal() {
		return dispatch => {
			EventDispatcher.success(dispatch,  CLOSE_REDIRECT_MODAL);
		};
	}

	export function openModal() {
		return dispatch => {
			EventDispatcher.success(dispatch, OPEN_MODAL);
		};
	}

	export function closeModal() {
		return dispatch => {
			EventDispatcher.success(dispatch, CLOSE_MODAL);
		};
	}

	export function openModalCB() {
		return dispatch => {
			EventDispatcher.success(dispatch, OPEN_MODAL_CB);
		};
	}
	export function openModal_2() {
		return dispatch => {
			EventDispatcher.success(dispatch, OPEN_MODAL_2);
		};
	}
	export function closeModal_2() {
		return dispatch => {
			EventDispatcher.success(dispatch, CLOSE_MODAL_2);
		};
	}
	export function refresh() {
		return dispatch => {
			EventDispatcher.success(dispatch, REFRESH);
		};
	}
	export function closeRefresh() {
		return dispatch => {
			EventDispatcher.success(dispatch, CLOSEREFRESH);
		};
	}
	export function openModalCB_2() {
		return dispatch => {
			EventDispatcher.success(dispatch, OPEN_MODAL_CB_2);
		};
	}
	export function openModalCB_3() {
		return dispatch => {
			EventDispatcher.success(dispatch, OPEN_MODAL_CB_3);
		};
	}
	export function closeModalCB_2() {
		return dispatch => {
			EventDispatcher.success(dispatch, CLOSE_MODAL_CB_2);
		};
	}
	export function closeModalCB_3() {
		return dispatch => {
			EventDispatcher.success(dispatch, CLOSE_MODAL_CB_3);
		};
	}
	export function closeModalCB() {
		return dispatch => {
			EventDispatcher.success(dispatch, CLOSE_MODAL_CB);
		};
	}



export function findCustomer() {
	return (dispatch, getState) => {
		const currentCustomer = LocalStorageService.getCurrentCustomer();
		const {messages: mainMessages={}} = getState();
		const {messages = {}} = mainMessages || {};
		if (currentCustomer === null) {
			this.fail(new Error({message: messages["common.error.no.customer.found"]}));
		} else {
			CommonService.findCustomer(currentCustomer.code)
				.then(response => {
						const {actionStatus, customers} = response;
						const {customer} = customers || [];
						const [firstCustomer] = customer || {};
						if (actionStatus === null || actionStatus.status === "FAIL") {
							this.fail(actionStatus);
						} else if (firstCustomer === null) {
							this.fail({ message: messages["common.error.no.customer.found"]});
						} else {
							const customer = firstCustomer
							const currentCust = new Customer(firstCustomer);
							LocalStorageService.setCurrentCustomer(currentCust);
							EventDispatcher.success(dispatch, FIND_CUSTOMER, {customer});
						}
					}
				).catch(error => {
					EventDispatcher.error(dispatch, FIND_CUSTOMER, error);

				}
			);
		}
	};
}



// WEBPACK FOOTER //
// ./src/opencell/actions/CustomerActions.js